"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _reactRedux = require("react-redux");
var _r10SourceLibrary = require("r10-source-library");
var _planHeader = _interopRequireDefault(require("./planHeader"));
var _ChangeTariffButton = _interopRequireDefault(require("./ChangeTariffButton"));
var _basicPlanDetails = _interopRequireDefault(require("./cardContent/basicPlanDetails"));
var _useTranslation = _interopRequireDefault(require("../hooks/useTranslation"));
var _useProps2 = _interopRequireDefault(require("../hooks/useProps"));
var _constants = require("../constants");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
var BasicPlan = function BasicPlan() {
  var t = (0, _useTranslation.default)();
  var _useProps = (0, _useProps2.default)(),
    showChangeTariff = _useProps.showChangeTariff;
  var _useSelector = (0, _reactRedux.useSelector)(function (state) {
      return state[_constants.PKG_NAME];
    }),
    rates = _useSelector.rates;
  var getTotalAmount = function getTotalAmount() {
    return rates.reduce(function (acc, el) {
      return acc + el.amount;
    }, 0);
  };
  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(_planHeader.default, null), /*#__PURE__*/_react.default.createElement(_r10SourceLibrary.GridRow, null, /*#__PURE__*/_react.default.createElement(_r10SourceLibrary.Divider, {
    appearance: "secondary"
  }), /*#__PURE__*/_react.default.createElement(_r10SourceLibrary.Spacing, {
    spacingLevel: {
      top: 2,
      bottom: 6
    }
  }, /*#__PURE__*/_react.default.createElement(_r10SourceLibrary.Heading, {
    size: 1,
    weight: 3,
    noMargin: true
  }, t('totalRates')))), /*#__PURE__*/_react.default.createElement(_basicPlanDetails.default, null), /*#__PURE__*/_react.default.createElement(_r10SourceLibrary.GridRow, {
    justify: "between",
    marginTop: 2,
    marginBottom: 6
  }, /*#__PURE__*/_react.default.createElement(_r10SourceLibrary.Heading, {
    size: 1,
    weight: 3,
    noMargin: true
  }, t('totalCost')), /*#__PURE__*/_react.default.createElement(_r10SourceLibrary.Heading, {
    dataAttributes: {
      'data-testid': 'total-cost'
    },
    size: 1,
    weight: 3,
    noMargin: true
  }, getTotalAmount(), rates[0].currency)), showChangeTariff && /*#__PURE__*/_react.default.createElement(_ChangeTariffButton.default, null));
};
var _default = BasicPlan;
exports.default = _default;